module.exports = "/_assets/images/branding/corval-logo-white.svg";